import { Input } from "../../ui/input";

export function PercentField({
  item,
  value,
  error,
  helperText,
  disabled,
  onChange,
  onBlur,
  className,
  noLimit = false,
  percentAcceptedLimit = 2,
  positionPercentValue = "left",
}) {
  const handleChange = (e) => {
    const input = e.target.value;
    
    // Allow decimal input but clean non-numeric characters
    const numericValue = input.replace(/[^0-9.-]+/g, "");
    
    // Handle empty input or just a minus sign
    if (numericValue === "" || numericValue === "-") {
      onChange({ target: { value: numericValue } });
      return;
    }
    
    // Prevent multiple decimal points or minus signs
    const decimalCount = (numericValue.match(/\./g) || []).length;
    const minusCount = (numericValue.match(/-/g) || []).length;
    
    if (decimalCount > 1 || minusCount > 1 || (numericValue.includes('-') && numericValue.indexOf('-') !== 0)) {
      return; // Don't update if invalid format
    }
    
    // Check decimal places (use percentAcceptedLimit or item.percentAcceptedLimit)
    const maxDecimals = item?.percentAcceptedLimit !== undefined ? item.percentAcceptedLimit : percentAcceptedLimit;
    const decimalIndex = numericValue.indexOf('.');
    if (decimalIndex !== -1 && numericValue.length - decimalIndex - 1 > maxDecimals) {
      return; // Don't update if more than allowed decimal places
    }
    
    const parsedValue = parseFloat(numericValue);
    
    // If it's not a valid number yet (like "10."), allow it for typing
    if (isNaN(parsedValue)) {
      // Only allow if it's a valid partial number (ends with . or -)
      if (numericValue.endsWith('.') || numericValue.endsWith('-') || numericValue === '') {
        onChange({ target: { value: numericValue } });
      }
      return;
    }
    
    // Skip limit validation if noLimit is true
    if (!noLimit) {
      // Check if the value exceeds 100 (don't allow the input)
      if (parsedValue > 100) {
        return; // Don't update the input - this should block "899" at "89"
      }
    }
    
    // Only pass valid numbers
    onChange({ target: { value: numericValue } });
  };

  return (
    <div className="relative">
      <Input
        type="text"
        placeholder={item.placeholder || "0.00"}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={disabled}
        className={`${error ? "border-red-500 hover:border-red-500 focus:border-red-500 pr-8" : "bg-white border-[#D9D9D9] pr-8"} ${
          disabled ? "disabled:text-[#595959]" : ""
        } ${className || ""}`}
        style={{ textAlign: positionPercentValue }}
      />
      <span className={`absolute right-3 top-1/2 -translate-y-1/2 text-sm pointer-events-none ${
        disabled ? "text-[#595959]" : "text-gray-500"
      }`}>%</span>
    </div>
  );
}
